/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaModalFooterAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaModalFooterAction({
  children,
  viewPath = "/DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction",
  type,
  onClick,
  disabled,
  text,
  marginLeft
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type={type}
 size="normal"
 onClick={onClick}
 stopPropagation={true}
 disabled={disabled}
 text={text}
 marginLeft={marginLeft || dtSpaceXs}
/>
{children}
</React.Fragment>)
}